module.exports = __webpack_public_path__ + "static/img/yangju.fcd001a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/productBanner/woman/banner/yangju.jpg
// module id = 768T
// module chunks = 0